import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { OnboardingComponent } from './onboarding.component';
import { OnboardingRoutingModule } from './onboarding-routing.module';
import { OnboardingForgetpasswordComponent } from './onboarding-forgetpassword/onboarding-forgetpassword.component';
import { OnboardingRegisterComponent } from './onboarding-register/onboarding-register.component';
import { OnboardingLoginComponent } from './onboarding-login/onboarding-login.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxUiLoaderModule,
    OnboardingRoutingModule
  ],
  declarations: [OnboardingComponent, OnboardingForgetpasswordComponent, OnboardingRegisterComponent, OnboardingLoginComponent]
})

export class OnboardingModule { }